export default {
	"home.AnErrorHasOccurredPleaseContactTheInstructorForTheScreenshot": "發生錯誤了，請截圖聯繫指導師",
	"home.MarketingMarketplaceHomePage": "行銷商城主頁",
	"home.MarketingMarketplace": "行銷商城"
}